import { Card, Stack, Typography } from '@mui/material';
import { IeoCountdown } from 'entities/crowdsale';
import { userModel } from 'entities/user';
import { COLOR_BG_ALPHA_53, useShallowSelector, useUpdateCrowdsaleData } from 'shared';

import { useWagmiAuth } from '../../app/providers';

import { useBuyCoins } from './lib';
import {
  AddReferralAccordion,
  BuyForm,
  CrowdsalePrice,
  CrowdsaleProgress,
  ReferralLinkAccordion,
  Status,
  UserStats,
} from './ui';

export const CrowdsaleWidget = () => {
  const { state: authState } = useWagmiAuth();
  const { totalSpend } = useShallowSelector(userModel.selectors.selectUserCrowdsaleInfo);
  const { form, validateField, currencyField, receiveAmount, stableAmount, isAuthenticated } = useBuyCoins();
  const {
    handleSubmit,
    handleMaxClick,
    control,
    isValid,
    errorMessage,
    errors,
    isDirty,
    register,
    onReferralAddressChange,
  } = form;
  const { onChangeStableAmount } = validateField;
  const { onCurrencyChange, currency } = currencyField;

  useUpdateCrowdsaleData();

  return (
    <Card
      component="form"
      onSubmit={handleSubmit}
      sx={{
        padding: { xs: 2, sm: 3 },
        minWidth: { xs: '100%', sm: 429 },
        maxWidth: { xs: '100%', sm: 429 },
        borderRadius: 8,
        background: COLOR_BG_ALPHA_53,
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" component="div">
          Presale{' '}
          <Typography variant="inherit" component="span" className="accent">
            Live
          </Typography>
        </Typography>
        <Status />
      </Stack>
      <Typography variant="body2" className="accent" textAlign="center" textTransform="uppercase" mt={1.5} mb={1}>
        100% match bonus
      </Typography>
      <IeoCountdown />
      <CrowdsaleProgress />
      <CrowdsalePrice />
      <BuyForm
        control={control}
        errorMessage={errorMessage}
        errors={errors}
        handleMaxClick={handleMaxClick}
        currency={currency}
        stableAmount={stableAmount}
        onChangeStableAmount={onChangeStableAmount}
        onCurrencyChange={onCurrencyChange}
        isAuthenticated={isAuthenticated}
        receiveAmount={receiveAmount}
        isValid={isValid}
        isDirty={isDirty}
      />
      <UserStats />
      <Stack mt={1} spacing={1}>
        <AddReferralAccordion register={register} onReferralAddressChange={onReferralAddressChange} errors={errors} />
        {authState.isAuthorized && Number(totalSpend) !== 0 && <ReferralLinkAccordion />}
      </Stack>
    </Card>
  );
};
